import { CertificationFormValues } from '@common/types/certification.types'
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useContext, useMemo, useState } from 'react'

type CertificationContextType = {
	certification: CertificationFormValues,
	setCertification: Dispatch<SetStateAction<CertificationFormValues>>
}

const CertificationContext = createContext<CertificationContextType | undefined>(undefined)

export const CertificationProvider = ({ children }: PropsWithChildren) => {
	const [certification, setCertification] = useState<CertificationFormValues>({
		course: '',
		obtaining: {
			isTrainer: false
		},
		date: '',
		trainerId: ''
	})

	const value = useMemo((): CertificationContextType => ({
		certification,
		setCertification
	}), [certification])

	return (
		<CertificationContext.Provider value={value}>
			{children}
		</CertificationContext.Provider>
	)
}

/**
 * Certification context
 */
export const useCertification = () => {
	const context = useContext(CertificationContext)
	if (!context) throw new Error('useCertification must be used within a LanguageProvider')
	return context
}
